<template>
  <div class="login">
    <v-card
      v-if="$route.query.redirect && !$_myUserData.isLoaded"
      flat
    >
      <v-card-text class="text-center">
        <div class="body-1 mb-3">
          ログイン中
        </div>
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-card-text>
    </v-card>
    <v-card
      v-else
      outlined
      max-width="900"
    >
      <v-card-title>ログイン</v-card-title>
      <v-card-text>
        <p>
          下記方法での初回ログインと同時にアカウントが登録されます。<br class="d-none d-sm-block">
          新規登録する際は、
          「<a
            :href="$router.resolve({ name: 'about' }).href"
            target="_blank"
          >当サイトについて</a>」、
          「<a
            :href="$router.resolve({ name: 'term-of-use' }).href"
            target="_blank"
          >利用規約</a>」、
          「<a
            :href="$router.resolve({ name: 'privacy-policy' }).href"
            target="_blank"
          >プライバシーポリシー</a>」を必ずご確認ください。<br class="d-none d-sm-block">
          また、登録と同時に利用規約及びプライバシーポリシーに同意したものとみなされます。
        </p>
        <v-btn
          depressed
          dark
          color="#1da1f2"
          :loading="isLodingLogin"
          @click="login"
        >
          <v-icon
            left
            class="mr-3"
          >
            fab fa-twitter
          </v-icon>
          <span>Twitterでログイン</span>
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<style lang="scss">
.login {
  > * {
    margin: auto;
  }
}
</style>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

export default {
  data: () => ({
    isLodingLogin: true
  }),
  async mounted() {
    try {
      const res = await firebase.auth().getRedirectResult();
      if (!res.user) {
        return;
      }
      const { uid, displayName, photoURL } = res.user;
      const username = res.additionalUserInfo.username;
      await firebase.firestore().collection('users').doc(uid).set({
        username, displayName, photoURL
      }, { merge: true });
      this.$_pushNotice('ログインに成功しました。', 'success');
    } catch (err) {
      this.$_pushNotice('ログインに失敗しました。', 'error');
      console.log(err);
    } finally {
      this.isLodingLogin = false;
    }
  },
  methods: {
    async login() {
      this.isLodingLogin = true;
      const provider = new firebase.auth.TwitterAuthProvider();
      await firebase.auth().signInWithRedirect(provider)
        .catch(err => {
          console.error(err);
          this.$_pushNotice('エラーが発生しました。', 'error');
        })
        .finally(() => {
          this.isLodingLogin = false;
        });
    }
  }
};
</script>
